import React from 'react'

const BoatingDashboard = () => {
  return (
    <div>
      Dashboard
    </div>
  )
}

export default BoatingDashboard
